var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 21,
    viewBox: "0 0 44 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 42.75,
    height: 20.25,
    rx: 3.75,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1066_2136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6138 5.61328H24.8863V15.6362H19.6138V5.61328Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9485 10.625C19.9485 8.58854 20.8524 6.78229 22.2416 5.61354C21.2206 4.76354 19.9318 4.25 18.5258 4.25C15.1949 4.25 12.5 7.10104 12.5 10.625C12.5 14.149 15.1949 17 18.5258 17C19.9318 17 21.2206 16.4865 22.2416 15.6365C20.8524 14.4854 19.9485 12.6615 19.9485 10.625Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 10.625C31.9999 14.149 29.3051 17 25.9742 17C24.5682 17 23.2793 16.4865 22.2583 15.6365C23.6643 14.4677 24.5514 12.6615 24.5514 10.625C24.5514 8.58854 23.6476 6.78229 22.2583 5.61354C23.2793 4.76354 24.5682 4.25 25.9742 4.25C29.3051 4.25 31.9999 7.11875 31.9999 10.625Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1066_2136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 12.75,
    fill: "white",
    transform: "translate(12.5 4.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.1522ad25d90c8dcb77ec8986c0b2fb01.svg";
export { ForwardRef as ReactComponent };